import React from 'react';
import { Leaf } from 'lucide-react';
import type { Plant } from '../../../types/plant';
import { useGrowingZone } from '../../../hooks/useGrowingZone';
import { isPlantCompatible } from '../../../utils/zoneUtils';

interface PlantZoneCompatibilityProps {
  plant: Plant;
  light?: boolean;
}

export default function PlantZoneCompatibility({ plant, light = false }: PlantZoneCompatibilityProps) {
  const { zone } = useGrowingZone();
  const isCompatible = zone ? isPlantCompatible(zone, plant.zone_min, plant.zone_max) : null;

  if (!zone) return null;

  return (
    <div className="flex items-center gap-3">
      <Leaf className={light ? "text-white" : "text-emerald-500"} />
      <div>
        <p className={`text-sm ${light ? "text-gray-300" : "text-gray-600"}`}>
          Zone Compatibility
        </p>
        <p className={`font-medium ${
          light 
            ? isCompatible ? "text-green-400" : "text-red-400"
            : isCompatible ? "text-green-600" : "text-red-600"
        }`}>
          {isCompatible 
            ? `Suitable for Zone ${zone}` 
            : `Not suitable for Zone ${zone}`}
        </p>
      </div>
    </div>
  );
}